import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { CellContext } from '@tanstack/react-table';

export interface EmspBoRfidBadgeOrderListBillingAddressFullNameCellProps
  extends CellContext<
    BackOfficeRfidBadgeOrderModel,
    BackOfficeRfidBadgeOrderModel['billingAddress']
  > {}

export const EmspBoRfidBadgeOrderListBillingAddressFullNameCell = (
  props: EmspBoRfidBadgeOrderListBillingAddressFullNameCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  const value = getValue();

  return <span>{value ? `${value.firstName} ${value.lastName}` : '—'}</span>;
};
